import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function Impressum({
  isOpen,
  onClose
}: {
  isOpen: boolean;
  onClose: () => void;
}) {
  // Lock body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-263">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[60]" onClick={onClose} data-id="element-264" />
          {/* Modal — centered on all screen sizes */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.95
      }} transition={{
        duration: 0.35,
        ease: [0.22, 1, 0.36, 1]
      }} className="fixed z-[61] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[calc(100%-2rem)] max-w-2xl max-h-[80vh] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col" data-id="element-265">
            {/* Header */}
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-[#e2e2e6] shrink-0" data-id="element-266">
              <h2 className="text-2xl font-heading text-[#1a1a2e]" data-id="element-267">
                Impressum
              </h2>
              <button onClick={onClose} className="w-10 h-10 rounded-full flex items-center justify-center text-[#8a8a9a] hover:text-[#1a1a2e] hover:bg-[#f5f5f7] transition-colors" aria-label="Schließen" data-id="element-268">
                <XIcon size={20} data-id="element-269" />
              </button>
            </div>

            {/* Content — scrollable */}
            <div className="overflow-y-auto flex-1 px-6 md:px-8 py-6 md:py-8 space-y-6 text-[#4a4a5a] font-light leading-relaxed text-sm" data-id="element-270">
              <section data-id="element-271">
                <h3 className="text-base font-medium text-[#1a1a2e] mb-3 font-body" data-id="element-272">
                  Angaben gemäß § 5 TMG
                </h3>
                <p data-id="element-273">
                  RAW Productions GmbH
                  <br data-id="element-274" />
                  Äußere Bayreuther Str. 59
                  <br data-id="element-275" />
                  90409 Nürnberg
                  <br data-id="element-276" />
                  Deutschland
                </p>
              </section>

              <section data-id="element-277">
                <h3 className="text-base font-medium text-[#1a1a2e] mb-3 font-body" data-id="element-278">
                  Kontakt
                </h3>
                <p data-id="element-279">
                  Telefon:{' '}
                  <a href="tel:+4917621226068" className="text-brand-accent hover:underline" data-id="element-280">
                    +49 176 21226068
                  </a>
                  <br data-id="element-281" />
                  E-Mail:{' '}
                  <a href="mailto:kontakt@rawproductionsgmbh.de" className="text-brand-accent hover:underline" data-id="element-282">
                    kontakt@rawproductionsgmbh.de
                  </a>
                </p>
              </section>

              <section data-id="element-283">
                <h3 className="text-base font-medium text-[#1a1a2e] mb-3 font-body" data-id="element-284">
                  Registereintrag
                </h3>
                <p data-id="element-285">
                  Eintragung im Handelsregister
                  <br data-id="element-286" />
                  Registergericht: Amtsgericht Nürnberg
                  <br data-id="element-287" />
                  Registernummer: HRB 41552
                </p>
              </section>

              <section data-id="element-288">
                <h3 className="text-base font-medium text-[#1a1a2e] mb-3 font-body" data-id="element-289">
                  Umsatzsteuer-ID
                </h3>
                <p data-id="element-290">
                  Umsatzsteuer-Identifikationsnummer gemäß § 27 a
                  Umsatzsteuergesetz:
                  <br data-id="element-291" />
                  DE362211253
                </p>
              </section>

              <section data-id="element-292">
                <h3 className="text-base font-medium text-[#1a1a2e] mb-3 font-body" data-id="element-293">
                  Vertretungsberechtigte Geschäftsführung
                </h3>
                <p data-id="element-294">Dimitri Kuksin</p>
              </section>

              <section data-id="element-295">
                <h3 className="text-base font-medium text-[#1a1a2e] mb-3 font-body" data-id="element-296">
                  Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
                </h3>
                <p data-id="element-297">
                  Dimitri Kuksin
                  <br data-id="element-298" />
                  RAW Productions GmbH
                  <br data-id="element-299" />
                  Äußere Bayreuther Str. 59
                  <br data-id="element-300" />
                  90409 Nürnberg
                </p>
              </section>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}